import React, { Component } from 'react';
import plus from '../../../Images/Daikin_Images/image/Add.png';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Switch from '../../Part_Sample/Switch';
import Select from '../../Part_Sample/Select';
import Editbox from '../../Part_Sample/Editbox';
import Button from '../../Part_Sample/Button';
import { isEmpty } from '../../Common/Common';

import Management_Point_Selection_Cell from '../../Part_Sample/Management_Point_Selection_Cell';

export default class Add_Edit_Account extends Component {
	constructor(props) {
		super(props);

		this.accounts = JSON.parse(JSON.stringify(this.props.param.accounts));
		let username = '';
		let password = '';
		let user_class = 'Admin';

		let points = {};

		let auth = {
			user_reg: false,
			sp_proh: false,
			mode_proh: false,
			points: points
		};

		let notify = false;
		let mail_alert = false;
		let mail_address = [];
		let lang = 'EN';

		let language_list = this.props.receiver.getLanguageList();
		this.language_options = [];
		for (let i in language_list) {
			this.language_options.push(<option selected value={language_list[i].value}>{language_list[i].display}</option>);
		}

		if (this.props.param.username != null) {
			let account = this.props.param.accounts[this.props.param.username];
			username = account.name;
			password = account.passwd;
			user_class = account['class'];
			if (!isEmpty(account.auth)) {
				if (account.auth.user_reg != null) auth.user_reg = account.auth.user_reg;
				if (account.auth.sp_proh != null) auth.sp_proh = account.auth.sp_proh;
				if (account.auth.mode_proh != null) auth.mode_proh = account.auth.mode_proh;
				if (account.auth.points != null) {
					for (let point_id in account.auth.points) {
						auth.points[point_id] = account.auth.points[point_id];
					}
				}
			}
			notify = account.notify;
			mail_alert = account.mail_alert;
			mail_address = account.mail_addr;
			lang = account.lang;
		}

		/*
		 *  Password is hashed in server side. No way to retrieve the original password.
		 *  Check if the password is changed.
		 *  If password is changed, send new password. Else send password = null
		 */
		this.is_password_changed = false;

		this.state = {
			username: username,
			password: password,
			user_class: user_class,
			auth: auth,
			notify: notify,
			mail_alert: mail_alert,
			mail_address: mail_address,
			lang: lang,
		}
	}

	handlePrevious = () => {
		//this.props.content_handler('User_Administration', { accounts: this.props.param.accounts });
		this.props.content_handler('User_Administration', { accounts: this.accounts });
	}

	handleChangeUsername = (val) => {
		this.setState({ username: val })
	}

	handleChangePassword = (val) => {
		this.is_password_changed = true;
		this.setState({ password: val })
	}

	handleChangeUserClass = (val) => {
		this.setState({ user_class: val })
	}

	handleToggleNotify = () => {
		this.setState({ notify: !this.state.notify });
	}

	handleChangeLanguage = (val) => {
		this.setState({ lang: val });
	}

	handleToggleMailAlert = () => {
		this.setState({ mail_alert: !this.state.mail_alert });
	}

	handleAddEmail = () => {
		let mail_address = this.state.mail_address;
		let next_index = mail_address.length;
		mail_address[next_index] = '';
		this.setState({ mail_address: mail_address });
	}

	handleChangeEmail = (index, e) => {
		let val = e.target.value;
		let mail_address = this.state.mail_address;
		mail_address[index] = val;
		this.setState({ mail_address: mail_address })
	}

	handleToggleUserReg = () => {
		let auth = this.state.auth;
		auth.user_reg = !auth.user_reg;
		this.setState({ auth: auth });
	}

	handleToggleUserOpLimit = () => {
		let auth = this.state.auth;
		auth.sp_proh = !auth.sp_proh;
		this.setState({ auth: auth });
	}

	handleToggleUserModeLimit = () => {
		let auth = this.state.auth;
		auth.mode_proh = !auth.mode_proh;
		this.setState({ auth: auth });
	}

	handleSelectMP = (val) => {
		let auth = this.state.auth;
		let is_management_selected = false;
		for (let point_id in auth.points) {
			if (point_id == val) {
				is_management_selected = true;
				auth.points[point_id] = !auth.points[point_id];
				break;
			}
		}

		//If the management point has not been added yet
		if (!is_management_selected) {
			auth.points[val] = true;
		}

		this.setState({ auth: auth });
	}

	handleRegister = () => {
		let tempName = this.state.username.split(/\s/).join('');  //check for names that are just spaces.

		if (tempName == '') {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}
		
		if (this.state.username == 'setup') {
			window.app.showToast(this.props.receiver.getString('cannot_use_setup'), 3000);
			return;
		}
		
		if (this.state.password == '') {
			window.app.showToast(this.props.receiver.getString('no_password'), 3000);
			return;
		}

		let account_details = {};
		account_details.name = this.state.username;
		account_details.passwd = this.is_password_changed == true ? this.state.password : null;
		account_details['class'] = this.state.user_class;

		// Remove whichever management points have false
		let auth = this.state.auth;
		for (let point_id in auth.points) {
			if (!auth.points[point_id]) {
				delete auth.points[point_id];
			}
		}

		account_details.auth = auth;
		account_details.notify = this.state.notify;
		account_details.notify_list = {};
		account_details.mail_alert = this.state.mail_alert;
		account_details.mail_addr = this.state.mail_address.filter(e => String(e).trim());
		account_details.lang = this.state.lang;

		if (this.props.param.username == null) {
			this.props.receiver.addAccount(account_details);
		} else {
			let account = this.props.param.accounts[this.props.param.username];
			account_details.id = account.id;
			this.props.receiver.modifyAccount(account_details);
		}
	}

	handleDelete = () => {
		this.props.receiver.deleteAccount({ name: this.props.param.username });
	}

	rcvAddAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteAccount(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'User_Administration';
			this.props.receiver.getAccounts();
		} else {
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let container_style = {
			width: this.props.width - 60,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
			textAlign: 'left',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			padding: 10,
		}

		const class_range = [];
		if (this.state.user_class == 'Admin') {
			class_range.push(<option selected value={'Admin'}>{this.props.receiver.getString('admin')}</option>);
			class_range.push(<option value={'User'}>{this.props.receiver.getString('user')}</option>);
		} else if (this.state.user_class == 'User') {
			class_range.push(<option value={'Admin'}>{this.props.receiver.getString('admin')}</option>);
			class_range.push(<option selected value={'User'}>{this.props.receiver.getString('user')}</option>);
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.username == null ? this.props.receiver.getString('add_account') : this.props.receiver.getString('edit_account')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 20, height: this.props.height - 120, overflow: 'auto' }}>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='username' read_only={this.props.param.username != null ? true : false} placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.username} />
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto' }}>
							<Editbox id='passwd' placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} />
						</div>

						<div id='general' style={container_style}>
							<div style={{}}>
								<span className="header">{this.props.receiver.getString('general')}</span>
							</div>
							<div id='user_class' style={{ marginLeft: 10, textAlign: 'left' }}>
								<div style={{ display: 'inline-block', width: this.props.width - 220 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('user_class')}</span>
								</div>
								<div style={{ display: 'inline-block', width: 150 }}>
									<div style={{ display: this.props.param.username != null ? 'inline-block' : 'none', width: '100%', textAlign: 'right' }}>
										<span style={{ marginRight: 10, fontWeight: 500, fontSize: 20 }}>{this.state.user_class}</span>
									</div>
									<Select
										style={{ display: this.props.param.username == null ? 'inline-block' : 'none' }}
										select_style={{ fontSize: 20, height: 35 }}
										options={class_range}
										value={this.state.user_class}
										onSelect={this.handleChangeUserClass}
									/>
								</div>
							</div>
							<div id='language' style={{ marginTop: 20, marginLeft: 10 }}>
								<div style={{ display: 'inline-block', width: this.props.width - 250 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('lang_notify')}</span>
								</div>
								<div style={{ display: 'inline-block', width: 180, verticalAlign: 'top' }}>
									<Select
										style={{ display: 'inline-block' }}
										select_style={{ fontSize: 20, height: 35 }}
										options={this.language_options}
										value={this.state.lang}
										onSelect={this.handleChangeLanguage}
									/>
								</div>
							</div>

						</div>
						<div id='notifications' style={{ ...container_style, display: this.state.user_class == 'Admin' ? 'block' : 'none' }}>
							<div>
								<span className="header">{this.props.receiver.getString('notifications')}</span>
							</div>
							<div id='notification' style={{ marginTop: 10, marginBottom: 10, marginLeft: 10 }}>
								<div style={{ display: 'inline-block', width: this.props.width - 120 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('push_notification')}</span>
								</div>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.notify} handleToggleSwitch={this.handleToggleNotify} />
							</div>
							<div id='mail_alert' style={{ marginTop: 5, marginLeft: 10 }}>
								<div style={{ display: 'inline-block', width: this.props.width - 120 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('mail_alert')}</span>
								</div>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.mail_alert} handleToggleSwitch={this.handleToggleMailAlert} />
							</div>
							<div id='mailing_list' style={{ marginTop: 15, marginLeft: 10 }}>
								<div style={{}}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('mailing_list')}</span>
								</div>
								{this.state.mail_address.map((email, index) => {
									return (
										<div style={{ textAlign: 'center' }}>
											<input
												value={email}
												type='text'
												style={{ border: '1px solid ' + this.props.colours.appBlue, marginTop: 10, width: this.props.width - 80, height: 25 }}
												onChange={(event) => this.handleChangeEmail(index, event)} />
										</div>
									)

								})}
								<div onClick={this.handleAddEmail} style={{ textAlign: 'center' }}>
									<img src={plus} style={{ width: 25, marginTop: 10, marginRight: 10 }} />
								</div>
							</div>
						</div>
						<div id='authority' style={{ ...container_style, marginBottom: 20, display: this.state.user_class == 'Admin' ? 'none' : 'block' }}>
							<div>
								<span className="header">{this.props.receiver.getString('authority')}</span>
							</div>

							<div id='op_limit' style={{ display: this.state.user_class == 'Admin' ? 'none' : 'block', marginTop: 5, marginLeft: 10, textAlign: 'left' }}>
								<div>
									<span className='footnote' style={{ fontSize: 12 }}>{this.props.receiver.getString('op_limit_explanation')}</span>
								</div>
								<div style={{ display: 'inline-block', width: this.props.width - 120 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('op_limit')}</span>
								</div>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.auth.sp_proh} handleToggleSwitch={this.handleToggleUserOpLimit} />
							</div>
							<div id='mode_limit' style={{ display: this.state.user_class == 'Admin' ? 'none' : 'block', marginTop: 5, marginLeft: 10, textAlign: 'left' }}>
								<div style={{ display: 'inline-block', width: this.props.width - 120 }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('mode_limit')}</span>
								</div>
								<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.auth.mode_proh} handleToggleSwitch={this.handleToggleUserModeLimit} />
							</div>
							<div id='target' style={{ display: this.state.user_class == 'Admin' ? 'none' : 'block', marginTop: 10, marginLeft: 10, maxHeight: this.props.height - 170, overflow: 'auto', textAlign: 'left' }}>
								<div style={{ textAlign: 'left' }}>
									<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('target')}</span>
								</div>
								<div>
									<span className='footnote' style={{ fontSize: 12 }}>{this.props.receiver.getString('target_explanation')}</span>
								</div>
								{Object.keys(window.app.state.point_list).map((point_id) => {
									let point_info = window.app.state.point_list[point_id];
									if (!isEmpty(point_info)) {
										return (
											<Management_Point_Selection_Cell
												style={{ width: this.props.width - 80 }}
												id={point_id}
												height={this.props.height}
												width={this.props.width}
												key={point_id}
												handleSetToggle={this.handleSelectMP}
												point_info={point_info}
												is_selected={this.state.auth.points[point_id]}
											/>
										)
									} else {
										return null;
									}
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}